module.exports = __webpack_public_path__ + "static/media/Union_right.e2f536e8.svg";